import { ReactElement } from 'react';

import Navbar from './Navbar';
import Footer from './Footer';
import { NavType } from '../../interfaces';

interface LayoutType {
    children: ReactElement;
    navProps?: NavType;
}

export default function Layout({ children, navProps }: LayoutType): JSX.Element {
    return (
        <div className="mx-auto ">
            <Navbar description={navProps?.description} title={navProps?.title} />
            <main>{children}</main>
            <Footer />
        </div>
    );
}
